import { SubscriptionType } from '@uma/react-commons/dist/index';
import React, { useEffect, useState } from 'react';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';
import { SubscriptionsCardProps } from '../SubscriptionsCard/types';
import { getHaveQuestionsRows } from './helpers/getHaveQuestionsRows';
import { getInstantInkAsyncRows } from './helpers/getInstantInkAsyncRows';
import { StyledCard } from '../../styles/styles';

export const HaveQuestions = ({
  subscription
}: SubscriptionsCardProps): React.ReactElement | null => {
  const { translate, northboundAPIs } = useDependencyManagerContext();
  const language = northboundAPIs?.v1.localization.language;
  const country = northboundAPIs?.v1.localization.country;

  const [rows, setRows] = useState(() =>
    getHaveQuestionsRows({
      subscription,
      translate
    })
  );

  useEffect(() => {
    let isMounted = true;

    if (subscription?.type === SubscriptionType.INSTANT_INK) {
      getInstantInkAsyncRows({
        subscription,
        translate,
        language,
        country
      })
        .then((asyncRows) => {
          if (isMounted) {
            setRows((prevRows) => [
              ...asyncRows,
              ...prevRows.filter((row) => row.index !== 0)
            ]);
          }
        })
        .catch(() => {
          // If the async call fails, fallback URLs are handled inside getVaSessionUrl, so the UI remains functional.
        });
    }

    return () => {
      isMounted = false;
    };
  }, [subscription, translate, language, country]);

  if (rows.length === 0) {
    return null;
  }

  return (
    <StyledCard
      title={{
        content: translate(
          'subscriptions.haveQuestions',
          'Have questions?'
        ) as string
      }}
      rows={rows}
      data-testid="have-questions-section"
    />
  );
};

export default HaveQuestions;
